import React, { useEffect, useState } from "react";
import { Images } from "../../../Controller";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";
import { CheckfundStatus } from "../../../ApiServices/Apifun";

const StatusPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState("0");
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const clientId = params.get("client_txn_id");
  console.log(clientId);
  const checkStatus = () => {
    const formdata = new FormData();
    formdata.append("transaction_id", clientId);
    CheckfundStatus(formdata)
      .then((res) => {
        if (res.message === "SUCCESS") {
          setState("1");
        } else if (res.message === "PENDING") {
          setState("0");
        } else if (res.message === "FAILED") {
          setState("2");
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    let interval;
    let count = 0;

    interval = setInterval(() => {
      count = count + 1;
      checkStatus();
      if (count === 6) {
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    }, 5000);
  }, []);
  return (
    <div className="flex justify-center items-center h-full">
      <div className="flex flex-col justify-center items-center">
        <img
          src={
            state === "0"
              ? Images.pending
              : state === "1"
              ? Images.success
              : Images.failed
          }
          className="w-52 animate-bounce"
          alt="success"
        />
        <p className="font-bold text-xl">
          Transaction{" "}
          {state === "0" ? "Pending" : state === "1" ? "Successfull" : "Failed"}
        </p>
        <Button
          style={{ color: "white" }}
          className="bg-primary mt-4 hover:border-none border-none"
        >
          Go To Report Page
        </Button>
      </div>
    </div>
  );
};

export default StatusPage;
